import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479edc2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "btn-live-booking"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-live" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "主播直播中 点击观看", -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "btn-live-booking"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tip" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "预约下场直播", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import LivePlayer from 'v-component/smart/live-player.vue';
import LiveAction from 'v-component/smart/live-action.vue';
import {withDefaults} from 'vue';
import {download} from 'common/util';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LivePlayer, {
      live: false,
      url: __props.info.playback_url,
      poster: __props.info.cover_pic_url,
      onClickProcess: _unref(download),
      onTouchEnd: _unref(download)
    }, null, 8 /* PROPS */, ["url", "poster", "onClickProcess", "onTouchEnd"]),
    _createVNode(LiveAction),
    _createCommentVNode(" <section\n        class=\"icon-watermark\"\n        @click.stop=\"download\"\n    /> "),
    (__props.info && __props.info.next_info)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(download) && _unref(download)(...args)))
        }, [
          (__props.info.next_info.status === '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})